"use strict";
import Barba from "barba.js";
import Env from "../base/env.js";
import Grid from "../components/moods/Grid";
import GridAccordion from "../fx/Accordion";
import Channels from "../base/channels";
import RegisterMail from "../components/RegisterMail";
import Lazyload from "../components/moods/Lazyload";
import { TweenLite, TimelineLite } from "gsap";

let page;

class Page {
  constructor(view = "") {
    this.view = view;
    this.classView = "currentView--magIndex";
    // Objects

    this.raf = undefined;
    this.accordions = [];
    // Fns
    this.completeLazyload = this.lazyloadIsComplete.bind(this);
    if (this.view.querySelector(".jsIsotope--view") != null) {
      this.grid = new Grid(view);
      this.grid.setup();
    }
    this.setupAccordion();
    this.moodletter = new RegisterMail(
      this.view.querySelector(".jsRegister--bandletter")
    );
    this.events();
    // Launch Fn
    this.funcLaunch = this.intro.bind(this);
    if (Env.framework.UI.launcher.LAUNCHED == false) this.channels();
  }

  createAccordions($items) {
    if ($items.length) {
      for (let i = 0; i < $items.length; i++) {
        const $item = $items[i];
        let instance = new GridAccordion($item);
        instance.setup();
        this.accordions.push(instance);
      }
    }
  }

  refreshAccordion() {}

  channels() {
    Channels.on("launcher::exit", this.funcLaunch);
  }

  destroy() {
    if (typeof this.grid != "undefined") {
      this.grid.destroy();
    }
    this.lazy.destroy();
    Channels.removeListener("lazyload::finalize", this.completeLazyload);
    Channels.removeListener("launcher::exit", this.funcLaunch);
  }

  events() {
    Channels.on("lazyload::finalize", this.completeLazyload);

    Env.framework.UI.listenTransitionUpdateBg(this.view);
  }

  finalize() {
    setTimeout(() => {
      if (Env.isVisiting === true) {
        this.intro();
      }
      this.lazy = new Lazyload(this.view, "mag");
    }, 100);
    Env.framework.UI.pinRefresh();
    Env.framework.UI.lazy();
  }

  intro() {
    const tl = new TimelineLite();
    const $header = this.view.querySelector(".mood-index__header");
    const $focus = this.view.querySelector(".mood-index__focus");
    const $grid = this.view.querySelector(".mood-index__receptor");

    tl.add([
      TweenLite.fromTo(
        $header,
        0.8,
        { opacity: 0, y: 10 },
        { opacity: 1, y: 0, ease: Power3.easeOut }
      ),
    ]);
    if ($focus !== null) {
      if (Env.mobileCSS === false) {
        tl.add(
          [
            TweenLite.fromTo(
              $focus,
              0.8,
              { opacity: 0, y: 20 },
              { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.1 }
            ),
          ],
          "-=.8"
        );
      }
    } else {
      tl.add(
        [
          TweenLite.fromTo(
            $grid,
            0.8,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.1 }
          ),
        ],
        "-=.8"
      );
    }
  }

  lazyloadIsComplete() {
    const $items = this.view.querySelectorAll(
      ".jsLazy--item:not(.jsLazy--isDone)"
    );
    this.grid.lazyUpdate($items);
    setTimeout(() => {
      this.createAccordions($items);
      Env.framework.UI.listenTransitionUpdateBg(this.view);
      PinUtils.build();
      Env.framework.UI.lazy();
    }, 500);
  }

  setupAccordion() {
    const $items = this.view.querySelectorAll(".jsAccordion--item");
    this.createAccordions($items);
  }
}

page = Barba.BaseView.extend({
  namespace: "magIndex",
  node: undefined,
  onEnter: function () {
    this.node = new Page(this.container);
    Env.$html.classList.add(this.node.classView);
  },
  onEnterCompleted: function () {
    this.node.finalize();
  },
  onLeave: function () {
    this.node.destroy();
  },
  onLeaveCompleted: function () {
    if (this.container.getAttribute("data-namespace") != this.namespace) {
      Env.$html.classList.remove(this.node.classView);
    }
  },
});

export default page;
